// "Last active" in the user tables (Settings → Users, Admin → company people, Admin → Super admins; 2026-09-26):
// public.user_activity, stamped by whoami while the app is open. A sign-in newer than that (an account whose app
// has not read whoami since) counts too; the admin pages have it and show it on hover.
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { dateTime, relativeTime } from '../lib/time';

/** The later of the two, or null when neither is known. */
export function lastActive(
  activeAt: string | null | undefined,
  signedInAt?: string | null,
): string | null {
  if (!activeAt) return signedInAt ?? null;
  if (!signedInAt) return activeAt;
  return new Date(signedInAt) > new Date(activeAt) ? signedInAt : activeAt;
}

export function LastActive({
  activeAt,
  signedInAt,
  timeZone,
}: {
  activeAt: string | null | undefined;
  /** admin pages only (auth.users) */
  signedInAt?: string | null;
  timeZone: string;
}) {
  const { t, i18n } = useTranslation();
  const at = lastActive(activeAt, signedInAt);
  if (!at) return <>{t('common.never')}</>;
  const exact = dateTime(at, i18n.language, timeZone) ?? '';
  const signIn = dateTime(signedInAt, i18n.language, timeZone);
  return (
    <Tooltip
      title={
        signIn ? (
          <>
            {exact}
            <br />
            {t('settings.users.last_sign_in', { at: signIn })}
          </>
        ) : (
          exact
        )
      }
    >
      <span>{relativeTime(at, i18n.language)}</span>
    </Tooltip>
  );
}
